import FormSection from './FormSection'
import { translations } from '../../data/translations'

const AdditionalSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.additional || translations.de.additional

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 18.1 Besondere Wünsche */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label htmlFor="besondere_wuensche">{t.besondereWuensche}</label>
          <textarea
            id="besondere_wuensche"
            name="besondere_wuensche"
            value={formData.besondere_wuensche || ''}
            onChange={(e) => updateFormData('besondere_wuensche', e.target.value)}
            placeholder={t.besondereWuenschePlaceholder}
            rows="4"
          />
        </div>
      </div>

      {/* 18.2 Aktuelle Herausforderungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label htmlFor="aktuelle_herausforderungen">{t.herausforderungen}</label>
          <textarea
            id="aktuelle_herausforderungen"
            name="aktuelle_herausforderungen"
            value={formData.aktuelle_herausforderungen || ''}
            onChange={(e) => updateFormData('aktuelle_herausforderungen', e.target.value)}
            placeholder={t.herausforderungenPlaceholder}
            rows="4"
          />
        </div>
      </div>

      {/* 18.3 Erfolgsmessung */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle3}</div>
        
        <div className="form-group">
          <label htmlFor="erfolgs_messung">{t.erfolgsMessung}</label>
          <textarea
            id="erfolgs_messung"
            name="erfolgs_messung"
            value={formData.erfolgs_messung || ''}
            onChange={(e) => updateFormData('erfolgs_messung', e.target.value)}
            placeholder={t.erfolgsMessungPlaceholder}
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="kpis">{t.kpis}</label>
          <input
            type="text"
            id="kpis"
            name="kpis"
            value={formData.kpis || ''}
            onChange={(e) => updateFormData('kpis', e.target.value)}
            placeholder={t.kpisPlaceholder}
          />
        </div>
      </div>

      {/* 18.4 Zusatzleistungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle4}</div>
        
        <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {t.zusatzleistungenOptionen.map(option => (
            <div key={option.value} className="checkbox-item">
              <input
                type="checkbox"
                id={`zus-${option.value}`}
                checked={(formData.zusatzleistungen || []).includes(option.value)}
                onChange={() => handleCheckboxChange('zusatzleistungen', option.value)}
              />
              <label htmlFor={`zus-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      {/* 18.5 Sonstiges */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle5}</div>
        
        <div className="form-group">
          <label htmlFor="sonstiges">{t.sonstiges}</label>
          <textarea
            id="sonstiges"
            name="sonstiges"
            value={formData.sonstiges || ''}
            onChange={(e) => updateFormData('sonstiges', e.target.value)}
            placeholder={t.sonstigesPlaceholder}
            rows="4"
          />
        </div>
      </div>
    </FormSection>
  )
}

export default AdditionalSection
